import React, { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';

import { styles } from './styles';

export default function TabComponent({
  tabs,
  customStyles = null,
  activeTabIndex = null,
  isPaddingNeed = true,
  orientation = 'horizontal',
}) {
  const classes = styles();
  const [tabIndex, setTabIndex] = useState(activeTabIndex ? activeTabIndex : 0);

  const tabProps = (index) => {
    return {
      id: `tab-${index}`,
    };
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        {...other}
      >
        {value === index && <div style={{ height: '100%' }}>{children}</div>}
      </div>
    );
  }

  const StyledTabs = withStyles(customStyles ? customStyles.tabs : null)(
    (props) => <Tabs {...props} />,
  );

  const StyledTab = withStyles(customStyles ? customStyles.tab : null)(
    (props) => <Tab {...props} />,
  );

  return (
    <div className={classes.root}>
      <StyledTabs
        value={tabIndex}
        orientation={orientation}
        onChange={(e, val) => setTabIndex(val)}
        centered
      >
        {tabs.map((tab) => (
          <StyledTab
            label={tab.name}
            key={tab.name}
            className={classes.tabTitle}
            disabled={tab.disabled}
            {...tabProps(0)}
          />
        ))}
      </StyledTabs>
      <div className={isPaddingNeed ? classes.tabPanelMain : ''}>
        {tabs.map((tab, index) => (
          <TabPanel
            value={tabIndex}
            index={index}
            key={tab.name}
            className={classes.tabPanel}
          >
            {tab.component}
          </TabPanel>
        ))}
      </div>
    </div>
  );
}
